// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';


export class ReservePlayerSlotAction implements flatbuffers.IUnpackableObject<ReservePlayerSlotActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ReservePlayerSlotAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsReservePlayerSlotAction(bb:flatbuffers.ByteBuffer, obj?:ReservePlayerSlotAction):ReservePlayerSlotAction {
  return (obj || new ReservePlayerSlotAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsReservePlayerSlotAction(bb:flatbuffers.ByteBuffer, obj?:ReservePlayerSlotAction):ReservePlayerSlotAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ReservePlayerSlotAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.LobbyReservePlayerSlot;
}

playerId():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
}

static startReservePlayerSlotAction(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.LobbyReservePlayerSlot);
}

static addPlayerId(builder:flatbuffers.Builder, playerId:number) {
  builder.addFieldInt16(1, playerId, 0);
}

static endReservePlayerSlotAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createReservePlayerSlotAction(builder:flatbuffers.Builder, type:ActionType, playerId:number):flatbuffers.Offset {
  ReservePlayerSlotAction.startReservePlayerSlotAction(builder);
  ReservePlayerSlotAction.addType(builder, type);
  ReservePlayerSlotAction.addPlayerId(builder, playerId);
  return ReservePlayerSlotAction.endReservePlayerSlotAction(builder);
}

unpack(): ReservePlayerSlotActionT {
  return new ReservePlayerSlotActionT(
    this.type(),
    this.playerId()
  );
}


unpackTo(_o: ReservePlayerSlotActionT): void {
  _o.type = this.type();
  _o.playerId = this.playerId();
}
}

export class ReservePlayerSlotActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.LobbyReservePlayerSlot,
  public playerId: number = 0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return ReservePlayerSlotAction.createReservePlayerSlotAction(builder,
    this.type,
    this.playerId
  );
}
}
